import { render, staticRenderFns } from "./VideoPrew.vue?vue&type=template&id=389ab28a&scoped=true&"
import script from "./VideoPrew.vue?vue&type=script&lang=js&"
export * from "./VideoPrew.vue?vue&type=script&lang=js&"
import style0 from "./VideoPrew.vue?vue&type=style&index=0&id=389ab28a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389ab28a",
  null
  
)

export default component.exports